// Format a UTC ISO timestamp string in a given IANA timezone, e.g. "America/Toronto".
// Output style: "YYYY-MM-DD HH:MM" (24-hour, zero-padded).
//
// Backend stores timestamps in UTC (DB session is UTC). The browser would otherwise
// render them in its local timezone, which is inconsistent across users. By passing
// the owner's / dealer's timezone explicitly we get a consistent display everywhere.

const FALLBACK_TZ = 'America/Toronto';

const TWO_DIGIT = { hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };

export function formatDateTime(isoString, tz) {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';

  const zone = tz || FALLBACK_TZ;

  try {
    const parts = new Intl.DateTimeFormat('en-CA', { ...TWO_DIGIT, timeZone: zone }).formatToParts(d);
    const get = (type) => parts.find(p => p.type === type)?.value || '';
    const year   = get('year');
    const month  = get('month');
    const day    = get('day');
    const hour   = get('hour');
    const minute = get('minute');
    return `${year}-${month}-${day} ${hour}:${minute}`;
  } catch (_e) {
    // Bad zone string → fall back to default
    return formatDateTime(isoString, FALLBACK_TZ);
  }
}

export function formatDate(isoString, tz) {
  const dt = formatDateTime(isoString, tz);
  return dt ? dt.split(' ')[0] : '';
}
